<template>
  <!-- 如果fixed == true  则div换成el-scrollbar -->
  <div class="app-scroll-bar">
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {},
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.app-scroll-bar {
  width: 100%;
  padding-left: 200px;
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
